import { useMemo } from "react";
import { useGroupsByParent } from "../groups/useGroupsByParent";

/**
 * Returns a map of zone name → available parking spots.
 *
 * The parking spots are derived from the Geotab group hierarchy:
 * Fairfleet Services → Parking → [location groups].
 * Each location group's `comments` field contains comma-separated parking spot names.
 * The group name matches the corresponding zone name.
 */
export function useParkingOptions() {
  const { data: parkingGroups = [], isLoading } = useGroupsByParent("Parking");

  const parkingOptionsMap = useMemo(() => {
    const map: Record<string, string[]> = {};
    for (const group of parkingGroups) {
      if (!group.comments) continue;
      const spots = group.comments
        .split(",")
        .map(s => s.trim())
        .filter(Boolean);
      if (spots.length > 0) {
        map[group.name] = spots;
      }
    }
    return map;
  }, [parkingGroups]);

  return { parkingOptionsMap, isLoading };
}
